module.exports = __webpack_public_path__ + "img/uk-ischemic-heart-disease-female.a9ccc26c.png";